import { render, staticRenderFns } from "./NewHighlightVideo.vue?vue&type=template&id=6c3dcac9&"
import script from "./NewHighlightVideo.vue?vue&type=script&lang=js&"
export * from "./NewHighlightVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports